$bog_ui_sidebar_item $mol_button_minor
	Icon $mol_icon
	label \
	active false
	collapsed? false
	sub /
		<= Icon
		<= Label $mol_view
			sub /
				<= label
	attr *
		^
		bog_ui_sidebar_item_active <= active
		bog_ui_sidebar_item_collapsed <= collapsed?
